import { fetch as http } from "./http";

/**
 * Save call activity log
 * @param sessionId - The session/call ID
 * @param logText - The activity log message
 * @returns Promise with API response
 */
export const saveCallActivityLog = async (
  sessionId: string,
  logText: string,
) => {
  try {
    // Detailed validation logging
    console.log("=== saveCallActivityLog called ===");
    console.log("Received sessionId:", sessionId, "Type:", typeof sessionId);
    console.log("Received logText:", logText, "Type:", typeof logText);

    // Validation
    if (
      !sessionId ||
      (typeof sessionId === "string" && sessionId.trim() === "")
    ) {
      console.error("❌ VALIDATION FAILED: Missing or empty sessionId");
      console.error("  sessionId value:", JSON.stringify(sessionId));
      console.error("  Stack trace:", new Error().stack);
      throw new Error("Session ID is required to save activity log");
    }

    if (!logText || (typeof logText === "string" && logText.trim() === "")) {
      console.error("❌ VALIDATION FAILED: Missing or empty logText");
      console.error("  logText value:", JSON.stringify(logText));
      console.error("  Stack trace:", new Error().stack);
      throw new Error("Log text is required to save activity log");
    }

    const formData = new FormData();
    formData.append("session_id", sessionId);
    formData.append("log_text", logText);

    console.log("✅ Creating FormData with:");
    console.log("  session_id:", sessionId);
    console.log("  log_text:", logText);

    const response = await http.Post(
      `/save/call-activity/log`,
      formData,
      "multipart/form-data",
    );

    console.log("✅ Call activity log saved successfully:", response);
    return response;
  } catch (error) {
    console.error("❌ Error saving call activity log:", error);
    throw error;
  }
};

/**
 * Get call activity logs
 * @param sessionId - The session/call ID
 * @param page - Page number for pagination (default: 1)
 * @param search - Search term to filter logs (optional)
 * @returns Promise with API response containing logs and pagination
 */
export const getCallActivityLogs = async (
  sessionId: string,
  page: number = 1,
  search?: string,
) => {
  try {
    let url = `/get/call-activity/log?session_id=${encodeURIComponent(sessionId)}&page=${page}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    const response = await http.Get(url);

    console.log("Call activity logs fetched successfully:", response);
    return response;
  } catch (error) {
    console.error("Error fetching call activity logs:", error);
    throw error;
  }
};

export const getCallTransferLogs = async (
  sessionId: string,
) => {
  try {
    let url = `/call_transfer_info/${sessionId}`;
    const response = await http.Get(url);
    return response;
  } catch (error) {
    console.error("Error fetching call activity logs:", error);
    throw error;
  }
};